import React, { Component } from 'react';
import _ from "lodash";
import viewHelper from '../../helpers/view';

class Cart extends Component {

    renderCartItems(cart) {
        return _.map(cart, (product) => {
            return (
                <tr key={product.id}>
                    <td>{product.quantity}</td>
                    <td>{product.description}</td>
                    <td>{viewHelper.formatCurrency(product.price, this.props.currency)}</td>
                    <td>{viewHelper.formatCurrency(product.tax, this.props.currency)}</td>
                    <td>{viewHelper.formatCurrency((parseFloat(product.price) + parseFloat(product.tax)), this.props.currency)}</td>
                </tr>
            )
        });
    }

    renderTotals(cart) {
        let totalAmount = _.sum(cart, (product) => product.price);
        let totalTax = _.sum(cart, (product) => product.tax);
        return(
            <tr>
                <td></td>
                <td></td>
                <td>{viewHelper.formatCurrency(totalAmount, this.props.currency)}</td>
                <td>{viewHelper.formatCurrency(totalTax, this.props.currency)}</td>
                <td><strong>{viewHelper.formatCurrency(totalAmount + totalTax, this.props.currency)}</strong></td>
            </tr>
        )
    }

    render () {
        const {cart} = this.props;
        return (
            <div className='row'>
                <div className='col-xs-12 col-md-12 col-lg-12'>
                    <table className='table'>
                        <thead>
                            <tr>
                                <th>Qty.</th>
                                <th>Product</th>
                                <th>Price</th>
                                <th>Tax</th>
                                <th>Total</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.renderCartItems(cart)}
                        </tbody>
                        <tfoot>
                            {this.renderTotals(cart)}
                        </tfoot>
                    </table>
                </div>
            </div>
        )

    }
}

export default Cart;
